'use client';

import { EPlatform } from '@/lib/enums';
import { useAppState } from '@/state/hooks/app.state.hook';

/**
 * Whether the player is on a phone or tablet, from the user agent the server
 * classified. The same answer on both sides of hydration, unlike
 * `react-device-detect`, which has no user agent on the server and would make
 * the document carry the desktop asset for a phone.
 */
export const useIsMobileDevice = (): boolean => {
  const { deviceType } = useAppState();

  return deviceType !== undefined && deviceType !== EPlatform.DESKTOP;
};
